'use client';

import Image from 'next/image';
import { copyToClipboard } from "@/utils/copy";
import userImg from '@/features/user-center/images/default-avatar.png';

import clsx from "clsx";
import toast from 'react-hot-toast';
import { useTranslations } from 'next-intl';
import { useEffect, useMemo } from "react";
import { useGetUserInfo } from "../../services/user";
import { levelMap, vipLevelIndexMap } from '@/features/vip/const';
import { useGetVipDetail } from '@/features/vip/services/vip';
import IconFont from '@/components/ui/iconFont';
interface Props {
  className?: string;
}
export default function UserInfo({ className }: Props) {
  const { data: userInfo, refetch: refetchUserInfo } = useGetUserInfo.useQueryHook({
    params: {},
    queryConfig: {
      enabled: false,
    },
  });
  const { data: vipDetail } = useGetVipDetail.useQueryHook({});
  const t = useTranslations('personal');
  const handleCopy = () => {
    // navigator.clipboard.writeText(userInfo?.userId || '');
    copyToClipboard(userInfo?.userId || '');
    toast(t('common.copied'));
  };
  useEffect(() => {
    refetchUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentLevel = useMemo(() => {
    return vipDetail?.user_membership?.level || -1;
  }, [vipDetail]);

  // 最高等级才展示小图标
  const isShowLevel = useMemo(() => {
    // return vipDetail?.user_membership?.level !== 0;
    return Number(vipDetail?.user_membership?.level) > 0 && vipDetail?.user_membership?.level === vipDetail?.user_membership?.next_membership?.level;
  }, [vipDetail]);

  return (
    <div className={clsx("flex items-center mt-9", className)} >
      <Image className="mr-[.9375rem] w-[3.1875rem] h-[3.1875rem] rounded-[8px]" src={userInfo?.avatarUrl || userImg} alt='user' width={51} height={51} />
      <div className={clsx("flex self-stretch flex-col justify-center")}>
        <div className="flex items-center">
          <p className="font-medium text-[.6875rem] text-secondary">ID:{userInfo?.userId}</p>
          <IconFont name="icon-copy" size={11} color='#a9b5cb' className="ml-2.5 pressable" onClick={handleCopy} />
        </div>
        <p className="mt-[.1875rem] font-medium text-xs text-white max-w-[10.25rem] truncate active:scale-90">{userInfo?.userName}</p>
        {isShowLevel && levelMap[currentLevel]?.titleImg && <div className='relative flex items-center mt-[.125rem]'>
          <Image className='w-auto h-[1.125rem] object-contain' src={levelMap[currentLevel]?.titleImg} alt="vip" width={84} height={18} />
          <div className='absolute left-0 top-0  w-[1.375rem] h-5 flex items-center justify-center mt-[-.0885rem] font-bold text-white text-[10px]  '>{vipLevelIndexMap[levelMap[currentLevel]?.showLevel || 1]?.indexStr}</div>
        </div>}

      </div>
      {/* <UserIcon name="more" className="w-1.5 h-2.5 ml-auto" /> */}
    </div>
  );
}